import React from 'react';
import Post from "./Post/Post";
import "./Posts.css";

const Posts = ({postData}) => {
    return (
        <div className="Posts">
            <table>
                {
                    postData.map(post => <Post key={post.postId} showId={true} {...post} />)
                }
            </table>
        </div>
    )
}

export default Posts;